module.exports = __webpack_public_path__ + "img/logo_app.e356ecc2.svg";